import { render, staticRenderFns } from "./CooperateStep1.vue?vue&type=template&id=1c06985f&scoped=true"
import script from "./CooperateStep1.vue?vue&type=script&lang=js"
export * from "./CooperateStep1.vue?vue&type=script&lang=js"
import style0 from "./CooperateStep1.vue?vue&type=style&index=0&id=1c06985f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c06985f",
  null
  
)

export default component.exports